export default __webpack_public_path__ + "static/media/IMG_0417.93d0f758.93d0f758.JPG";